// data 参数类型
export const DATA_METHODS = ['put', 'post', 'patch']

// 请求方法类型
export const REQUEST_METHODS = ['request', 'get', 'delete', 'head', 'options', 'post', 'put', 'patch']



// WEBPACK FOOTER //
// ./src/plugins/request/constant.js